
/**
 * @ngdoc directive
 * @name titlepanel
 *
 * @description
 * Titlepanel
 */
module.directive('titlepanel', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '=',
            breadcrumb: '=?',
            showtitle: '@?',
            showbreadcrumb: '@?',
            preventfillbreadcrumb: '@?',
            showsearch: '@?',
            type: '@?',
            pricing: '=?',
            teaser: '=?',
            css: '@?',
            theme: '=?',
            category: '@?'
        },
        controller: ['$scope', '$rootScope', '$filter', 'tools', '$location', 'pattern', function($scope, $rootScope, $filter, tools, $location, pattern) {
            $scope.tools = tools;
            $scope.title = '';
            $scope.subtitle = '';
            $scope.site = $rootScope.config.site;
            $scope.pageUrl = $location.absUrl();
            $scope.pattern = pattern;

            if (angular.isUndefined($scope.showtitle) || $scope.showtitle == null) {
                $scope.showtitle = 'true';
            }

            if (!$scope.breadcrumb) {
                $scope.breadcrumb = [
                    { label: $filter('translate')('home'), state: 'homepage' }
                ];
            }

            // title may have a subtitle to display
            var formatTitle = function (label) {
                switch(typeof label) {
                    case 'object':
                        $scope.title = label.title;
                        $scope.subtitle = label.subtitle;
                        break;
                    case 'string':
                        $scope.title = label;
                        $scope.subtitle = '';
                        break;
                    default:
                        $scope.title = '';
                        $scope.subtitle = '';
                        break;
                }
            };

            $scope.$watchCollection('label', function (newValue) {
                if (newValue) {
                    if($scope.preventfillbreadcrumb ) {
                        formatTitle(newValue);
                    } else {
                        $scope.breadcrumb.push({ label: newValue });
                    }
                }
            });
            $scope.checknotranlate = function(text) {
                if($scope.pattern.noTranslatePattern.test(text)){
                    return "no"
                } else {
                    return "yes"
                }
            }
        }],
        templateUrl: 'src/components/titlepanel/titlepanel.html'
    };
});
